import request from '@/utils/request';

// 接口请求测试
export function submitMessage(data) {
  return request({
    url: '/api/v2/appInfo/submitMessage',
    method: 'post',
    data: data
  })
}